/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type LinkedInConnectResponseStatus = typeof LinkedInConnectResponseStatus[keyof typeof LinkedInConnectResponseStatus];


export const LinkedInConnectResponseStatus = {
  connected: 'connected',
  checkpoint_required: 'checkpoint_required',
} as const;
